import React, { createContext, useState, useContext, ReactNode, useEffect } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";
import config from "../../../config";

// 替换为真实的 API 地址
const credit_API = config.SURVEY_CREDITS_AND_PAYMENTS_API_BASE_URL + "credits"
const payment_API = config.SURVEY_CREDITS_AND_PAYMENTS_API_BASE_URL  + "payments"

interface CreditsContextType {
  credits: number | undefined;
  fetchCredits: (email: string) => Promise<void>;
  deductCredits: (amount: number, email: string) => Promise<boolean>;
}


interface CreditsProviderProps {
    children: ReactNode;
}
  

interface CreditsContextType {
  credits: number | undefined;
  fetchCredits: (email: string) => Promise<void>;
  deductCredits: (amount: number, email: string) => Promise<boolean>;
  isCreditLoading: boolean;
}

const CreditsContext = createContext<CreditsContextType | undefined>(undefined);

export const CreditsProvider: React.FC<CreditsProviderProps> = ({ children }) => {
  const [credits, setCredits] = useState<number | undefined >(undefined);
  const [isCreditLoading, setIsCreditLoading] = useState<boolean>(true);
  const { email } = useAuth();

  const fetchCredits = async (email: string) => {
    try {
        setIsCreditLoading(true); // 开始加载
      const response = await axios.get(credit_API, { params: { email } });
      if (response.data && typeof response.data.Credits === "number") {
        setCredits(response.data.Credits);
      } else {
        setCredits(0);
      }
    } catch (error) {
      setCredits(0);
    } finally {
        setIsCreditLoading(false); // 加载完成
    }
  };

  const deductCredits = async (amount: number, email: string) => {
    try {
      const response = await axios.put(
        credit_API,
        {
          email,
          changeAmount: -amount,
          reason: "Deduction for Facial analysis",
          relatedPaymentId: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
        setCredits((prevCredits) => prevCredits? prevCredits : 0 - amount);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (email) {
      fetchCredits(email); // 初始化时加载信用点数
    } else {
      setIsCreditLoading(false); // 如果没有 email，直接结束加载状态
    }
  }, [email]);

  return (
    <CreditsContext.Provider value={{ credits, fetchCredits, deductCredits, isCreditLoading }}>
      {children}
    </CreditsContext.Provider>
  );
};

export const useCredits = () => {
  const context = useContext(CreditsContext);
  if (!context) {
    throw new Error("useCredits must be used within a CreditsProvider");
  }
  return context;
};
